import { apiFetch } from "../utils/api";
import type { WorkshopCarAgentOutput } from "./types/ai";

export interface OrderAiInputResponse {
  ok: boolean;
  hasInspection: boolean;
  input: unknown | null;
}

export interface OrderAiAnalysisResponse {
  ok: boolean;
  created: boolean;
  payload: WorkshopCarAgentOutput | null;
}

export const fetchOrderAiInput = (
  orderId: string
): Promise<OrderAiInputResponse> =>
  apiFetch<OrderAiInputResponse>(`/orders/${orderId}/ai-input`);

export const runOrderAiAnalysis = (
  orderId: string
): Promise<OrderAiAnalysisResponse> =>
  apiFetch<OrderAiAnalysisResponse>(`/orders/${orderId}/ai-analysis/run`, {
    method: "POST",
  });

